import type { ReactNode, FC, ReactElement } from 'react';
import useWindowSize from '@customHooks/useWindowSize';
import Popup from 'reactjs-popup';
import type { EventType, PopupPosition } from 'reactjs-popup/dist/types';
import { jsxNotifications } from '@utils/notifications';
import { Picture } from '@ui';
import icons from '@icons';
import { observer } from 'mobx-react';
import './index.scss';

const {
  rocket: { white: rocketWhiteFilled }
} = icons.Fill;

interface TooltipProps {
  on?: EventType | EventType[];
  tooltipText: ReactNode;
  children: ReactElement;
  open?: boolean;
  onClose?: () => void;
  className?: string;
  position?: string;
  repositionOnResize?: boolean;
  offsetY?: number;
  keepTooltipInside?: boolean;
  centeredText?: boolean;
  arrowColor?: string;
  arrow?: boolean;
  positionImp?: PopupPosition | PopupPosition[];
  ignoreTooltip?: boolean;
  componentText?: ReactElement | boolean;
  isShowMobileNotification?: boolean;
}

const Tooltip: FC<TooltipProps> = observer(
  ({
    on = 'hover',
    tooltipText,
    componentText = false,
    children,
    open,
    onClose,
    className,
    position,
    repositionOnResize,
    offsetY,
    keepTooltipInside = 'body',
    centeredText,
    arrowColor = '#6D6D6D',
    ignoreTooltip,
    isShowMobileNotification = false,
    ...props
  }) => {
    const { isMobile, isDesktop } = useWindowSize();
    if (isShowMobileNotification && isMobile) {
      return (
        <div
          onClick={e => {
            e.stopPropagation();
            jsxNotifications({
              position: 'bottom',
              comp: (
                <div className='flex items-center gap-3'>
                  <Picture icon={rocketWhiteFilled} width={24} height={24} />
                  <span className='text-xs'>
                    Вам доступна быстрая доставка от 30 мин. Только для товаров
                    со значком «ракета».
                  </span>
                </div>
              )
            });
          }}
        >
          {children}
        </div>
      );
    }
    if (ignoreTooltip) {
      return children;
    }
    return (
      <Popup
        on={on}
        open={open}
        trigger={children}
        position={
          props?.positionImp
            ? props.positionImp
            : position || isDesktop
            ? 'top center'
            : 'bottom center'
        }
        closeOnDocumentClick
        onClose={onClose}
        arrow={props.arrow}
        repositionOnResize={repositionOnResize}
        offsetY={offsetY ?? 0}
        keepTooltipInside={keepTooltipInside}
        arrowStyle={{
          color: arrowColor
        }}
        contentStyle={{
          zIndex: 'var(--z-tooltip)'
        }}
        {...props}
      >
        <div
          style={{
            textAlign: centeredText ? 'center' : 'left'
          }}
          className={`Tooltip ${className || ''}`}
        >
          {componentText || tooltipText}
        </div>
      </Popup>
    );
  }
);

export default Tooltip;
